import { getAnalyticsItemType } from '@mb/lib';
import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';

export const mapMaterialsForAnalytics = (
  data: ProductSearchMaterial[] = [],
  currentColor: string,
  itemListId: string,
  itemListName: string,
  eventLocation: string | null = null,
) => {
  const configLang =
    typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : null;
  const currency = configLang === 'EU' ? 'EUR' : 'USD';
  const isQuickview = ['mini-pdp', 'quick-view', 'quickview'].includes(
    (eventLocation || '').toLowerCase(),
  );

  const gaType = data?.map((item, index) => {
    const colorway = item.colorVariants?.items?.find(
      (color) => color.image_url === item.thumbnailImageUrl?.split('?')?.[0],
    );
    let itemColor = null;
    if (colorway != null) {
      itemColor = colorway?.exact_color;
    }
    const finishesColor = item?.configData?.color;

    let itemId = item.sku;
    try {
      itemId = item?.configurations[0]?.items[0]?.sku;
    } catch (e) {
      console.log(`Error in mapMaterialsForAnalytics: ${e.message}`);
    }

    const finalObj: any = {
      item_id: itemId,
      item_name: item.name,
      item_brand: item.manufacturer,
      item_type: getAnalyticsItemType(item),
      ...getAnalyticsItemCategoriesByTaxonomy(item.taxonomy ?? []),
      index: item.gridIndex || index + 1,
      price: 0,
      quantity: 1,
      item_list_id: isQuickview
        ? item?.isDigital
          ? 'digital_sampling'
          : itemListId
        : itemListId,
      item_list_name: isQuickview
        ? item?.isDigital
          ? 'Digital sampling'
          : itemListName
        : itemListName,
      item_variant: finishesColor || currentColor || itemColor || '',
    };

    if (item.associatedItem != null) {
      finalObj['associated_item'] = item.associatedItem || '';
    }

    return finalObj;
  });

  return { gaType, currency };
};
